import request from '@/utils/request'

/*
 * 用户账号密码登录
 * @param data
 * @return  promise对象
 */
export function USER_LOGIN(data) {
  return request({
    url: '/web/user/user/login',
    method: 'post',
    data
  })
}

/*
 * 获取用户基本信息获取
 * @param token
 * @return  promise对象
 */
export function USER_INFO_GET(token) {
  return request({
    url: '/web/user/user/info_get',
    method: 'get',
    params: { token }
  })
}

/*
 * 获取用户信息获取
 * @param token
 * @return  promise对象
 */
export function USER_GET(params) {
  return request({
    url: '/web/user/user',
    method: 'get',
    params
  })
}

/*
 * 用户注销登录
 * @param data
 * @return  promise对象
 */
export function USER_LOGOUT(data) {
  return request({
    url: '/web/user/user/logout',
    method: 'post',
    data
  })
}

/*
 * 获取微信登录识别码
 * @param params
 * @return  promise对象
 */
export function WX_STATE_GET(params) {
  return request({
    url: '/web/user/user/wxstate',
    method: 'get',
    params
  })
}

/*
 * 用户微信登录
 * @param data
 * @return  promise对象
 */
export function WX_LOGIN(data) {
  return request({
    url: '/web/user/user/wx_login',
    method: 'post',
    data
  })
}

/*
 * 用户同意协议激活
 * @param data
 * @return  promise对象
 */
export function USER_ACTIVATE(data) {
  return request({
    url: '/web/user/user/activate',
    method: 'post',
    data
  })
}

/*
 * 获取用户登录验证码
 * @param params
 * @return  promise对象
 */
export function CODE_GET(id, params) {
  return request({
    url: `/web/user/user/code_get/${id}`,
    method: 'get',
    params
  })
}

/*
 * 登录验证码验证
 * @param data
 * @return  promise对象
 */
export function CODE_TEST(data) {
  return request({
    url: '/web/user/user/code_test',
    method: 'post',
    data
  })
}

/*
 * 发送邮箱注册验证码
 * @param data
 * @return  promise对象
 */
export function EMAIL_CODE(data) {
  return request({
    url: '/web/user/user/email_code',
    method: 'post',
    data
  })
}

/*
 * 用户邮箱注册
 * @param data
 * @return  promise对象
 */
export function REGISTER(data) {
  return request({
    url: '/web/user/user/register',
    method: 'post',
    data
  })
}

// MODEL 定义的变量
export const VARS = {
  // 用户类型
  TYPE: {
    GENERAL: {
      value: '1',
      label: '普通'
    },
    WX: {
      value: '2',
      label: '微信'
    },
    STORE: {
      value: '3',
      label: '商城'
    }
  },
  // 性别
  SEX: {
    MALE: {
      value: '1',
      label: '男'
    },
    FEMALE: {
      value: '2',
      label: '女'
    }
  },
  // 账户类型
  STATUS: {
    STOP: {
      value: '-1',
      label: '已禁用'
    },
    WAIT: {
      value: '0',
      label: '待激活'
    },
    OPEN: {
      value: '1',
      label: '已激活'
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/user/user.js